import { render, staticRenderFns } from "./HandlePlanMenu.vue?vue&type=template&id=28c4941e&scoped=true&"
import script from "./HandlePlanMenu.vue?vue&type=script&lang=js&"
export * from "./HandlePlanMenu.vue?vue&type=script&lang=js&"
import style0 from "./HandlePlanMenu.vue?vue&type=style&index=0&id=28c4941e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4941e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
